<template>
  <div>
    <shopadmin-notice-modal ref="notice"></shopadmin-notice-modal>
    <shopadmin-past-banquet-modal ref="pastBanquet"></shopadmin-past-banquet-modal>
  </div>
</template>

<script>
import ShopadminNoticeModal from './noticeModal.vue';
import ShopadminPastBanquetModal from './pastBanquetModal.vue';

export default {
  components: {
    'shopadmin-notice-modal': ShopadminNoticeModal,
    'shopadmin-past-banquet-modal': ShopadminPastBanquetModal,
  },
  async mounted() {
    if (window.data.su) {
      return;
    }
    await this.$refs.notice.showIfNeeded();
    await this.$refs.pastBanquet.showIfNeeded();
  },
};
</script>
